import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {Observable, of, Subject, throwError, TimeoutError} from 'rxjs';
import { AuthService } from './auth.service';
import {catchError, delay, finalize, flatMap, map, take, timeout, withLatestFrom} from 'rxjs/operators';
import { LoggerService } from './logger.service';
import { TechnicalWorksService } from './technical-works.service';

const extendedTimeouts = [
  '/images',
  '/reference-period-report',
  '/validations/report',
  '/assignment/case'
];

@Injectable({
  providedIn: 'root'
})
export class ApiInterceptorService implements HttpInterceptor {

  private tokenRefreshExecuted = false;

  private tokenRefresh$$: Subject<void> = new Subject();

  constructor(
      private injector: Injector
  ) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const auth = this.injector.get(AuthService);
      const payload =  auth.payload;
      const token = payload ? (req.url.indexOf('api/renew') < 0 ? payload.token : payload.refreshToken) : null;
      let timeoutValue = 30000;
      extendedTimeouts.forEach((e) => {
        if (req.url.indexOf(e) >= 0) {
          timeoutValue = 600000;
        }
      });
      req = this.addToken(req, token);
      return next.handle(req).pipe(
         timeout(timeoutValue),
         map((event: HttpEvent<any>) => {
             if (event instanceof HttpResponse) {
                 if (event.status === 200) {
                     this.tokenRefreshExecuted = false;
                 }
             }
             // console.log('event', event);
             return event;
         }),
         catchError((error: HttpErrorResponse) => {
             if (req.url.indexOf('api/log') < 0) {
                 const message = `status=${error.status}, statusText=${error.statusText}, message=${error.message} url=${req.url}, body=${JSON.stringify(req.body)}`;
                 const logger = this.injector.get(LoggerService);
                 logger.error(message).subscribe(() => {
                     console.error('error log', message);
                 });
             }
             if ((error.status === 440) && req.url.indexOf('api/renew') < 0 && req.url.indexOf('api/login') < 0) {
                 if (this.tokenRefreshExecuted) {
                     return of(1).pipe(delay(5000), flatMap(() => {
                         const payload2 = auth.payload;
                         if (payload2) {
                             const req2 = this.addToken(req, payload2.token);
                             return next.handle(req2);
                         } else {
                             return throwError(error);
                         }
                     }));
                 }
                 this.tokenRefreshExecuted = true;
                 return auth.refresh().pipe(
                     catchError((err) => {
                         const router = this.injector.get(Router);
                         auth.logout().subscribe(() => {
                             router.navigateByUrl('/login');
                         });
                         return err;
                     }),
                     finalize(() => {
                         this.tokenRefreshExecuted = false;
                         this.tokenRefresh$$.next();
                     }),
                     flatMap((data: any) => {
                        const req2 = this.addToken(req, auth.payload.token);
                        return next.handle(req2);
                     })
                 );
             } else if ((error.status === 401) && req.url.indexOf('api/log') < 0 && req.url.indexOf('api/login') < 0) {
                 const router = this.injector.get(Router);
                 auth.logout().subscribe(() => {
                     router.navigateByUrl('/login');
                 });
             } else if (error.status === 503) {
                 const tw = this.injector.get(TechnicalWorksService);
                 tw.isTechnicalWorksMode = true;
             }
             return throwError(error);
         })
     );
  }

  addToken(req: HttpRequest<any>, token: string|null): HttpRequest<any> {
      const requestOptions: any = {};
      if (req.body) {
          requestOptions.body = req.body;
      }
      if (token) {
          requestOptions.setHeaders = {
              Authorization: 'Bearer ' + token,
          };
      }
      return req.clone(requestOptions);
  }
}

